/**
 * BeBobi — <bebobi-variant-sync>: keeps Liquid-rendered wording in step with
 * the selected variant on the standard Horizon product page.
 *
 * Horizon does not morph the whole product section on a variant switch: the
 * variant picker re-fetches the product page and dispatches
 * VariantUpdateEvent (assets/variant-picker.js) with the parsed document, and
 * every interested element morphs itself from it (product-inventory,
 * product-price, the add-to-cart button...). This element does the same for
 * the delivery note, the "Wysyłka i zwroty" row and the PDP trust badges,
 * whose copy depends on the variant's stock state
 * (snippets/bebobi-delivery-state.liquid). Modelled on assets/product-inventory.js.
 */
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class BebobiVariantSync extends HTMLElement {
  connectedCallback() {
    this._section = this.closest('.shopify-section, dialog');
    this._section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this._section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
    this._section = null;
  }

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }
    const id = this.dataset.syncId;
    if (!id) return;
    const fresh = event.detail.data.html.querySelector(`bebobi-variant-sync[data-sync-id="${CSS.escape(id)}"]`);
    if (!fresh) return;
    morph(this, fresh, { childrenOnly: true });
  };
}

if (!customElements.get('bebobi-variant-sync')) {
  customElements.define('bebobi-variant-sync', BebobiVariantSync);
}
